import React, { FC, ReactNode } from 'react';
import { Popup, PopupProps } from 'semantic-ui-react';

interface PopupWrapperProps {
  children: ReactNode;
}

export const NumLikes: FC<PopupWrapperProps> = ({ children }) => (
  <Popup
    trigger={children}
    content="推文數"
    position="bottom center"
  />
);

export const NumHates: FC<PopupWrapperProps> = ({ children }) => (
  <Popup
    trigger={children}
    content="噓文數"
    position="bottom center"
  />
);

export const NumReplies: FC<PopupWrapperProps> = ({ children }) => (
  <Popup
    trigger={children}
    content="回文數"
    position="bottom center"
  />
);

export const NumArticles: FC<PopupWrapperProps> = ({ children }) => (
  <Popup
    trigger={children}
    content="文章數"
    position="bottom center"
  />
);